import { range } from 'lodash';
import { format, roundToNearestMinutes } from 'date-fns';
import { formatDateToString, getHourLists } from 'utils/time';
import { utcToZonedTime } from 'date-fns-tz';
const hourlists = getHourLists();

const getCurrentDateTimeInTimezone = (buildingTimezone: string) => {
  const currentDate = new Date();
  // Convert current UTC date to building timezone
  const tzDate = utcToZonedTime(currentDate, buildingTimezone);
  return tzDate;
};

export const formatedTimeIndex = (time: string | number | Date, tz: string) => {
  // The below line is converting a given UTC date/ and time to the specified timezone.
  const buildingDate = utcToZonedTime(new Date(time), tz);

  return hourlists.indexOf(format(roundToNearestMinutes(buildingDate, { nearestTo: 15 }), 'p'));
};

/*
  Getting the Index for the Booked Slots  
*/
export const formatBookedIndex = (
  bookings: any,
  date: any,
  start: number,
  end: number,
  tz: string,
  bookingStartDate: string,
  bookingEndDate: string
) => {
  // Convert Selected Date to the building's timezone
  const tzSelectedDate = utcToZonedTime(date, tz);
  // Convert start and end date and time to Date format (in provided timezone)
  const startDate = utcToZonedTime(new Date(bookingStartDate), tz);
  const endDate = utcToZonedTime(new Date(bookingEndDate), tz);

  /* The below lines of code are converting the selected date, booking start date, and booking end date
  into a specific format (YYYY-MM-DD) using the `formatDateToString` function. */
  const formattedSelectedDate = formatDateToString(tzSelectedDate);
  const formattedBookingStartDate = formatDateToString(startDate);
  const formattedBookingEndDate = formatDateToString(endDate);

  const length =
    (start == 0 && end == 1) ||
    (formattedBookingStartDate !== formattedSelectedDate &&
      formattedBookingEndDate !== formattedSelectedDate)
      ? 0
      : range(start, end).length;

  const filteredBooking = bookings?.filter((booking: { start: number | Date }) => {
    const tzBookingStartDate = utcToZonedTime(booking.start, tz);
    return format(tzBookingStartDate, 'P') === format(tzSelectedDate, 'P');
  });

  const indexArray: number[] = [];
  filteredBooking?.map((booking: { start: number | Date; end: number | Date }) => {
    const startIndex = formatedTimeIndex(booking.start, tz);
    const endIndex = formatedTimeIndex(booking.end, tz) - 1;
    indexArray.push(...range(startIndex, endIndex + 1));
  });

  // Remove indexes only if it exists in `indexArray`
  if (indexArray.indexOf(start) !== -1) {
    indexArray.splice(indexArray.indexOf(start), length);
  }
  return indexArray;
};

/*
  Getting the index for the Selected Slots
*/
export const formatSelectedIndex = (start: number, end: number) => {
  if (start === end) {
    return [start];
  }
  return range(start, end + 1);
};

/*
  Getting the index for the Disabled Slots
*/
// This block is to disable bookings before Current time
const getDisabledQuarterhour = (currentMinute: number) => {
  const quarterHourList = ['00', '15', '30', '45'];
  const result = quarterHourList.map((hourlist) => currentMinute - parseInt(hourlist, 10));
  let blockMin = '';
  for (let i = 0; i < 5; i++) {
    if (result[i] === Math.abs(result[i])) {
    } else if (result[i] !== Math.abs(result[i])) {
      blockMin = quarterHourList[i - 1].toString();
      break;
    } else {
      blockMin = '45';
      break;
    }
  }
  return blockMin;
};

const disableBeforeCurRange = (
  selectedDate: number | Date,
  openTime: string,
  buildingTimezone: string
) => {
  const currentDateTime = getCurrentDateTimeInTimezone(buildingTimezone);
  const selectedDateTime = utcToZonedTime(selectedDate, buildingTimezone);
  let disableBeforeTime = '';

  /* The code block is checking if the selected date is the current date. If it is, it disables the
  time slots before the current time within the same day. */
  if (format(currentDateTime, 'P') === format(selectedDateTime, 'P')) {
    // Check if the selected date is the current date
    const currentHour = currentDateTime.getHours();
    const currentMinute = currentDateTime.getMinutes();

    const disableQuarterMin = getDisabledQuarterhour(currentMinute);

    // Disable times before the current time within the same day
    if (currentHour === selectedDateTime.getHours()) {
      disableBeforeTime = format(selectedDate, 'h').concat(
        ':',
        disableQuarterMin,
        ' ',
        format(selectedDate, 'a')
      );
    }
    // Disable all time blocks before the current time and the current time block as well, when the user tries to make same day bookings
    const formattedSelectedDate: string = format(selectedDateTime, 'yyyy-MM-dd');
    const formattedCurrentDate: string = format(currentDateTime, 'yyyy-MM-dd');
    if (formattedSelectedDate === formattedCurrentDate) {
      disableBeforeTime = format(currentDateTime, 'h').concat(
        ':',
        disableQuarterMin,
        ' ',
        format(currentDateTime, 'a')
      );
    }
  }
  return range(hourlists.indexOf(openTime) - 1, hourlists.indexOf(disableBeforeTime) + 1);
};

// this block is to allow user to book within allowed time slots
const openTimeIndex = (openTime: string) => {
  return range(hourlists.indexOf(openTime) - 1);
};

const closeTimeIndex = (closeTime: string) => {
  return range(hourlists.indexOf(closeTime), hourlists.length);
};

export const formatDisabledIndex = (
  openTime: string,
  closeTime: string,
  selectedDate: Date,
  buildingTimezone: string
) => {
  return openTimeIndex(openTime).concat(
    disableBeforeCurRange(selectedDate, openTime, buildingTimezone),
    closeTimeIndex(closeTime)
  );
};
